module.exports = __webpack_public_path__ + "static/2-ba6d19bb6e79f425cdf6d4f1fbac322a.jpg";